import React, {useState} from 'react';
import {makeStyles} from '@material-ui/styles';
import {Paper, Tabs, Tab, Grid, useMediaQuery} from '@material-ui/core';
import {Form, CompanyList, EditCompany} from './components';
import {DeleteDialog} from '../../components';

import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import PropTypes from 'prop-types';
import InfoCompany from './components/InfoCompany';
import CompanyToolbar from './components/CompanyToolbar';

import mockData from './components/CompanyList/data';
import theme from 'theme';
import {useSelector} from 'react-redux';

function TabPanel(props) {
  const {isSmall, children, value, index, ...other} = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3} style={isSmall ? {padding: 2} : {}}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    'aria-controls': `scrollable-auto-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: '100%',
  },
  formContainer: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    padding: theme.spacing(4),
  },
  listContainer: {
    height: '100%',
    marginTop: 20,
  },
  input: {
    marginTop: theme.spacing(4),
  },
  ReactCropContainer: {
    marginTop: theme.spacing(6),
    padding: theme.spacing(3),
    border: '3px dashed rgba(0,0,0,0.1)',
  },
  alertContainer: {
    padding: theme.spacing(2),
    marginTop: theme.spacing(15),
    backgroundColor: theme.palette.primary.light + '1c',
    border: '2px solid ' + theme.palette.primary.dark,
    borderRadius: 4,
    '&  > *': {
      color: theme.palette.primary.dark,
    },
  },
  alertIcon: {
    margin: -8,
    marginLeft: theme.spacing(1),
  },
}));

const AddCompany = () => {
  const classes = useStyles();
  const isSmall = useMediaQuery(theme.breakpoints.down('xs'));
  let Pr_inventory = useSelector((state) => state.permission);
  const current_role = useSelector((state) => state.role);
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const toggleDeleteDialog = () => setShowDeleteDialog(!showDeleteDialog);

  const [showInfoDialog, setShowInfoDialog] = useState(false);
  const toggleInfoDialog = () => setShowInfoDialog(!showInfoDialog);

  const [showEditDialog, setEditInfoDialog] = useState(false);
  const toggleEditDialog = () => setEditInfoDialog(!showEditDialog);

  const [data] = useState(mockData);

  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const [idSel, setIdSelDialog] = useState('0');
  const [DataSel, setDataSel] = useState([]);
  function handleIdChange(newId) {
    setIdSelDialog(newId);
  }
  function SelectData(newData) {
    setDataSel(newData);
  }

  const [reloadPage, setReloadpage] = useState(false);
  function reloadFunction() {
    setReloadpage(!reloadPage);
  }

  const companyInfo = {
    name: 'شرکت برق منطقه ای یزد',
    code: 89199999999,
    fax: '035-8233308',
    phone: '035-8233300',
    address:
      'لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با استفاده از طراحان گرافیک است، لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با استفاده از طراحان گرافیک است، ',
  };
  return (
    <React.Fragment>
      {showDeleteDialog ? (
        <DeleteDialog
          id={idSel}
          reloadFunc={reloadFunction}
          type="Company"
          onClose={toggleDeleteDialog}
          open={showDeleteDialog}
          title="حذف شغل"
          desc={` ایا مایل به حذف ${DataSel.map((c) => c.name)} هستید؟`}
        />
      ) : (
        ''
      )}

      {/* <DeleteDialog
        onClose={toggleDeleteDialog}
        open={showDeleteDialog}
        title="حذف شرکت"
        desc="ایا مایل به حذف این شرکت هستید؟"
      /> */}

      {showInfoDialog ? (
        <InfoCompany
          onAccept={toggleInfoDialog}
          onClose={toggleInfoDialog}
          company={DataSel || undefined}
          id={idSel}
          title="اطلاعات بیشتر"
          open={showInfoDialog}
        />
      ) : (
        ''
      )}

      {showEditDialog ? (
        <EditCompany
          onAccept={toggleEditDialog}
          onClose={toggleEditDialog}
          data={DataSel || undefined}
          reloadFunc={reloadFunction}
          id={idSel}
          title="اطلاعات بیشتر"
          open={showEditDialog}
        />
      ) : (
        ''
      )}

      {/* <EditCompany
        onAccept={toggleEditDialog}
        onClose={toggleEditDialog}
        data={data || undefined}
        id={idSel}
        title="اطلاعات بیشتر"
        open={showEditDialog}
      /> */}

      <Paper square className={classes.root}>
        <Tabs
          value={value}
          onChange={handleChange}
          variant="fullWidth"
          indicatorColor="secondary"
          textColor="secondary"
          aria-label="icon label tabs example"
        >
          {current_role == 'Super-Admin' ||
          Pr_inventory.indexOf('company.add') != -1 ? (
            <Tab label="ثبت شغل جدید" />
          ) : (
            ''
          )}
          {current_role == 'Super-Admin' ||
          Pr_inventory.indexOf('company.view') !== -1 ||
          Pr_inventory.indexOf('company.viewAny') !== -1 ? (
            <Tab label="لیست مشاغل" />
          ) : (
            ''
          )}
        </Tabs>
        {current_role == 'Super-Admin' ||
          Pr_inventory.indexOf('company.add') != -1 ? (
        <TabPanel
          isSmall={isSmall}
          value={value}
          index={0}
          style={{padding: 10}}
        >
          <Grid item xs={12} sm={12}>
            {isSmall ? (
              <Form />
            ) : (
              <Paper className={classes.formContainer}>
                <Form />
              </Paper>
            )}
          </Grid>
        </TabPanel>
        ) : (
          ''
        )} 
          {current_role == 'Super-Admin' ||
          Pr_inventory.indexOf('company.view') !== -1 ||
          Pr_inventory.indexOf('company.viewAny') !== -1 ? (
        <TabPanel
          isSmall={isSmall}
          value={value}
          index={  Pr_inventory.indexOf('company.add')== -1 && current_role != 'Super-Admin' ?0:1 }
          style={{padding: 10}}
        >
          <Grid style={{marginTop: 20}} item xs={12} sm={12}>
            {/* <CompanyToolbar/> */}
            {isSmall ? (
              <CompanyList
                reload={reloadPage}
                selData={SelectData}
                ChangeId={handleIdChange}
                showEdit={toggleEditDialog}
                onDelete={toggleDeleteDialog}
                onInfo={toggleInfoDialog}
                edit={showEditDialog}
                del={showDeleteDialog}
                info={showInfoDialog}
              />
            ) : (
              <Paper className={classes.listContainer}>
                <CompanyList
                  reload={reloadPage}
                  selData={SelectData}
                  ChangeId={handleIdChange}
                  showEdit={toggleEditDialog}
                  onDelete={toggleDeleteDialog}
                  onInfo={toggleInfoDialog}
                  edit={showEditDialog}
                  del={showDeleteDialog}
                  info={showInfoDialog}
                />
              </Paper>
            )}
          </Grid>
        </TabPanel>
         ) : (
          ''
        )}
      </Paper>
    </React.Fragment>
  );
};

export default AddCompany;
